import { LitElement, html } from 'lit';
import AppContextConsumer from '../../../shared/context/app-context/AppContextConsumer';
import styles from './styles';
import '../../../shared/components/button/Button';

class PartnersLogin extends LitElement {
  static styles = styles;

  static properties = {
    loginBtnUrl: {
      type: String,
    },
  };

  constructor() {
    super();
    this.logingBtnUrl = '';
  }

  context = AppContextConsumer(this);

  #getPartnersUrl(env) {
    let partnersLoginUrl = 'https://login.tenable.com/samlp/acBiHkx5cwsrFedV2M8OsFYq1Zq4ng5f?connection=Username-Password-Authentication';
    if (env === 'dev' || env === 'local') partnersLoginUrl = 'https://login-staging.tenable.com/samlp/tVRa6nSV4WKXvsX1aIkzXucDwvSX1vMy?connection=Username-Password-Authentication';
    if (env === 'staging') partnersLoginUrl = 'https://dev-login.tenablesecurity.com/samlp/sfdfJ9QLaq7mna9RSKQM1g6EdIoJTzAG?connection=Username-Password-Authentication';

    return partnersLoginUrl;
  }

  connectedCallback() {
    super.connectedCallback();
    this.loginBtnUrl = this.#getPartnersUrl(this.context.value?.env);
  }

  render() {
    const isOpenPartners = this.context.value?.type === 'openPartners';
    const logo = isOpenPartners
      ? 'https://static.tenable.com/partners/tenable_open_black.png'
      : 'https://static.tenable.com/partners/tenable-assure-logo.png';
    const heading = isOpenPartners ? 'Tenable Open Partner Portal' : 'Tenable Partner Portal';
    const description = isOpenPartners
      ? 'Access the Tenable OPEN partner portal for a one-stop view of joint marketing benefits, developer guides, product access and technical documentation.'
      : 'Access the Tenable Partner Portal for a one-stop view of sales and technical enablement, demand generation marketing, pipeline management, and analytics.';

    return html`
      <div class="login-container w-50">
        <div class="panel panel-default login-panel">
          <img src="${logo}" alt="Tenable">
          <div class="panel-heading">
            <h2>${heading}</h2>
          </div>
          <div class="panel-body">
            <h4>${description}</h4>
          </div>
          <a href="${this.loginBtnUrl}">
            <tenable-button class="login-btn" size="lg">Login</tenable-button>
          </a>
        </div>
      </div>
    `;
  }
}

customElements.define('tenable-partners-login', PartnersLogin);
